module.exports = __webpack_public_path__ + "img/triangle_phone-middle.8b1a9763.png";